import { usePatientEligibilityWarning } from '../model/usePatientEligibilityWarning';
import { PatientEligibilityWarningDialog } from './PatientEligibilityWarningDialog';

export interface PatientEligibilityWarningProps {
  userId: string;
}

export function PatientEligibilityWarning({ userId }: PatientEligibilityWarningProps) {
  const model = usePatientEligibilityWarning(userId);

  return (
    <PatientEligibilityWarningDialog
      open={model.open}
      issues={model.issues}
      isSuggesting={model.isSuggesting}
      onOpenChange={model.onOpenChange}
      onContinue={model.onContinue}
      onSuggestNext={() => void model.onSuggestNext()}
    />
  );
}
